import React from 'react';
import { CheckIcon, PickaxeIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { assurances, checkoutUrl, productBrand, productEdition } from '../data/offer';
export function FinalCta() {
  return <section className="border-t border-slate-800 bg-slate-900/60 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-58" data-mp="19g0bxfdwzqiu">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-59" data-mp="15bsmffzmu6jk">
        <h2 id="final-title" className="text-balance text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl" data-id="element-60" data-mp="1jclja7depdpu">
          <span className="inline-flex items-center gap-2" data-id="element-61" data-mp="1ed8xzr26oepd">
            <PickaxeIcon className="h-8 w-8 shrink-0 text-sky-400" aria-hidden="true" data-id="element-62" data-mp="1t2on72m2gc2y" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-extrabold uppercase tracking-[.16em] text-amber-400 sm:text-2xl" data-id="element-63" data-mp="1o3lf19ashpqr">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-slate-300" data-id="element-64" data-mp="1x4jj1rl89x9c">
          Creata per insegnanti di scienze, tecnologia e geografia della scuola secondaria e degli istituti tecnici.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full sm:w-auto" data-id="element-65" data-mp="s45uyad7htxx">
          Ottieni ora l&apos;Edizione Docenti
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-slate-300" data-id="element-66" data-mp="122vdm5cxfif8">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-67" data-mp="163fbxc98ks2y">
              <CheckIcon className="h-4 w-4 text-sky-400" aria-hidden="true" data-id="element-68" data-mp="1b31mfdxoju82" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}